<div
  class="upload-btn-wrapper dropdown__button cell flex-container align-middle"
  (click)="folderButtonTouched && folderSelector.click()"
>
  <button
    (mouseenter)="folderButtonTouched = true"
    (mouseleave)="folderButtonTouched = false"
    class="dropdown__button align-middle"
  >
    <span class="dropdown__icon padding-right-1">
      <rav-icon name="folder"></rav-icon>
    </span>
    Import Folder
  </button>
  <input
    #folderSelector
    (change)="filesSelected(folderSelector.files)"
    (click)="cleanCache($event)"
    type="file"
    class="custom-file-input"
    webkitdirectory
    data-cy="upload-folder"
  />
</div>
